import type { InputHTMLAttributes } from 'react';

type NumberFieldProps = {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  placeholder?: string;
  suffix?: string;
  min?: number;
  max?: number;
  step?: number;
  width?: number | string;
  align?: 'left' | 'right' | 'center';
  disabled?: boolean;
  ariaLabel?: string;
} & Pick<InputHTMLAttributes<HTMLInputElement>, 'autoFocus' | 'onBlur' | 'onFocus'>;

export function NumberField({
  value,
  onChange,
  placeholder = '—',
  suffix,
  min,
  max,
  step = 1,
  width,
  align = 'right',
  disabled,
  ariaLabel,
  ...rest
}: NumberFieldProps) {
  return (
    <div
      className="number-field"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        width,
      }}
    >
      <input
        type="number"
        inputMode="decimal"
        value={value ?? ''}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => {
          const raw = e.target.value;
          if (raw === '') {
            onChange(undefined);
            return;
          }
          const n = Number(raw);
          if (Number.isFinite(n)) onChange(n);
        }}
        className="number-field-input"
        style={{
          width: '100%',
          minWidth: 0,
          padding: '10px 12px',
          fontFamily: 'var(--font-mono)',
          fontSize: 15,
          fontWeight: 500,
          textAlign: align,
          borderRadius: 8,
          border: '1px solid var(--line)',
          background: value === undefined ? 'var(--surface-2)' : 'var(--surface)',
          color: 'var(--ink)',
          outline: 'none',
        }}
        {...rest}
      />
      {suffix && (
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 12,
            color: 'var(--ink-3)',
          }}
        >
          {suffix}
        </span>
      )}
    </div>
  );
}
